import { LocaleKey } from 'src/locales';

const SUPPORTED_LANGS: LocaleKey[] = ['en', 'es'];

export function isSupportedLang(lang: string | null | undefined): lang is LocaleKey {
	return typeof lang === 'string' && SUPPORTED_LANGS.includes(lang.toLowerCase() as LocaleKey);
}
